export default __webpack_public_path__ + "static/media/4-instru.3841d2ed.png";